import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerDepartmentService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetAllDepartments = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const allDepartmentsOptions = useQuery(
    ['getAllDepartmentsOptions'],
    async () => {
      return await handleRequest(
        CustomerDepartmentService.getApiCustomerApiAppCustomerDepartmentCustomerDepartments()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return allDepartmentsOptions;
};

export default useGetAllDepartments;
